var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitorList" } },
    [
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: _vm.cols(),
          dataSource: _vm.rows,
          loading: _vm.loading,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            {
              key: "connectionTimeSlot",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("date")(item.connectionTime)) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "urlSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                          zIndex: 99999999999999,
                        },
                        expression:
                          "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n                zIndex: 99999999999999,\n            }",
                      },
                    ],
                    attrs: { content: item.visitingPage },
                  },
                  [
                    item.visitingPage
                      ? _c(
                          "a",
                          {
                            staticClass: "webAdressMask",
                            attrs: {
                              target: "_blank",
                              href: item.visitingPage,
                            },
                          },
                          [
                            _vm._v(
                              "\n                " + _vm._s(item.visitingPage)
                            ),
                          ]
                        )
                      : _c("a", { staticClass: "webAdressMask" }, [
                          _vm._v(" " + _vm._s("-")),
                        ]),
                  ]
                )
              },
            },
            {
              key: "actions",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key: "actions-(" + item._id + ")(" + _vm.$i18n.locale + ")",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-end",
                        staticStyle: { "margin-right": "-10px !important" },
                      },
                      [
                        !_vm.conversations.find(function (c) {
                          return c.visitor._id === item._id
                        })
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                                  },
                                ],
                                staticClass: "custom-button",
                                attrs: {
                                  id: "joinChat",
                                  content: _vm.$t("message.startChatDesc"),
                                  "data-v-step": "16",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.startChat(item._id)
                                  },
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#49c550",
                                  },
                                  attrs: { theme: "filled", type: "message" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !!_vm.conversations.find(function (c) {
                          return (
                            c.visitor._id === item._id &&
                            !c.users.includes(_vm.user._id) &&
                            c.users.length !== 0
                          )
                        })
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                                  },
                                ],
                                staticClass: "custom-button",
                                attrs: {
                                  id: "watchChat",
                                  content: _vm.$t("message.watch"),
                                  "data-v-step": "16",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.observeChat(item._id)
                                  },
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#49c550",
                                  },
                                  attrs: { theme: "filled", type: "eye" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mt-3" },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.liveVisitorCount,
              "data-v-step": "17",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }